import { useDispatch, useSelector } from "react-redux"
import { useProcessActions } from "~/hooks/useProcessActions"
import {
  SetAuthenticationErrorPayload,
  SetIsAuthenticatedPayload,
  SetIsAuthenticatingPayload,
  VNZAuth,
} from "~/redux/state/VNZAuth"
import { RootState } from "~/redux/store"

export const useVNZAuthenticationState = () => {
  const { logoutVNZ } = useProcessActions()
  const dispatch = useDispatch()
  const state = useSelector((state: RootState) => state.VNZAuth)

  const setIsAuthenticating = (
    payload: Omit<SetIsAuthenticatingPayload, "provider">
  ) => {
    dispatch(VNZAuth.actions.setIsAuthenticating(payload))
  }

  const setIsAuthenticated = (
    payload: Omit<SetIsAuthenticatedPayload, "provider">
  ) => {
    dispatch(VNZAuth.actions.setIsAuthenticated(payload))
  }

  const setAuthenticationError = (
    payload: Omit<SetAuthenticationErrorPayload, "provider">
  ) => {
    dispatch(VNZAuth.actions.setAuthenticationError(payload))
  }

  const restoreAuthenticationState = () => {
    dispatch(VNZAuth.actions.restoreAuthenticationState())
  }

  return {
    state,
    setIsAuthenticating,
    setIsAuthenticated,
    logout: logoutVNZ,
    setAuthenticationError,
    restoreAuthenticationState,
  }
}
